import type { WiwState } from '@/store';

import type { Interval } from 'luxon';

export const getReportDateRange = (state: WiwState): Interval => state.reporting.customReportBuilder.dateRange;
